import { CHAT_SIZE_OPTIONS } from "@/constants/chatSize";

export const CHAT_SIZE_CATEGORY_VALUES = Object.values(CHAT_SIZE_OPTIONS).map(({ value }) => value);

export type ChatSizeCategoryValue = (typeof CHAT_SIZE_CATEGORY_VALUES)[number];

export const CHAT_SIZE_CATEGORY_VALUE_SET: ReadonlySet<string> = new Set(CHAT_SIZE_CATEGORY_VALUES);
